// extracted by mini-css-extract-plugin
module.exports = {"Logo":"logo_Logo__7M4rj"};